import { render } from "./InviiTelematiciDogane.vue?vue&type=template&id=73e279a8&scoped=true"
import script from "./InviiTelematiciDogane.vue?vue&type=script&lang=js"
export * from "./InviiTelematiciDogane.vue?vue&type=script&lang=js"

import "./InviiTelematiciDogane.vue?vue&type=style&index=0&id=73e279a8&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e279a8"]])

export default __exports__